import React from "react";
import { LocaleProvider } from "./src/i18n";

import './src/styles/variables.css'
import './src/styles/global.css'
import "./src/styles/index.scss";
export const onServiceWorkerUpdateReady = () => window.location.reload();

export const wrapPageElement = ({ element, props }) => (
  <LocaleProvider pathname={props.location.pathname}>{element}</LocaleProvider>
);
